import { render, staticRenderFns } from "./memberClassTypeRadio.vue?vue&type=template&id=5784d8f5&"
import script from "./memberClassTypeRadio.vue?vue&type=script&lang=js&"
export * from "./memberClassTypeRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports